export const CONFIG_DATA = {
  desktop: 'R-A-447162-65',
  mobile: 'R-A-447162-64'
};
